import { render, staticRenderFns } from "./roomConfiguration.vue?vue&type=template&id=1b3a53a6&scoped=true&"
import script from "./roomConfiguration.vue?vue&type=script&lang=js&"
export * from "./roomConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./roomConfiguration.vue?vue&type=style&index=0&id=1b3a53a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a53a6",
  null
  
)

export default component.exports